import { Card } from 'antd';
import type { JSX } from 'react';
import { Navigate } from 'react-router';

import type { UserRole } from '../enum';
import { useAppSelector } from '../hooks';

export const RequireAuth = ({ requiredRoles, children }: { requiredRoles: UserRole[]; children: JSX.Element }) => {
  const isLoggedIn = useAppSelector((state) => Boolean(state.authSlice.authResult.token));
  const userHasRequiredRole = useAppSelector(
    (state) => state.authSlice.currentUser.role && requiredRoles.includes(state.authSlice.currentUser.role),
  );

  if (isLoggedIn && userHasRequiredRole) {
    return children;
  } else if (isLoggedIn) {
    return (
      <Card title="Page not found">
        <p>Please select a page from the navigation bar on the left.</p>
      </Card>
    );
  }

  return <Navigate to="/login" />;
};
